import { useEffect, useRef } from 'react'
import type { Action } from '../../domain/action'
import type { Area } from '../../domain/area'
import type { Objective } from '../../domain/objective'
import type { Specialization } from '../../domain/specialization'
import { specializationNames } from '../../domain/specialization'
import { CheckIcon, CloseIcon } from './Icons'
import { useI18n } from '../../i18n'

interface Props {
  area: Area | null
  objective: Objective | null
  actions: Action[]
  specializations: Specialization[]
  open: boolean
  saving: boolean
  onClose: () => void
  onToggle: (action: Action) => Promise<boolean>
}

export const ObjectiveActionsSheet = ({ area, objective, actions, specializations, open, saving, onClose, onToggle }: Props) => {
  const { copy: { common, goalActions } } = useI18n()
  const dialogRef = useRef<HTMLDialogElement>(null)
  useEffect(() => {
    const dialog = dialogRef.current
    if (!dialog) return
    if (open && !dialog.open) dialog.showModal()
    if (!open && dialog.open) dialog.close()
  }, [open])
  if (!area || !objective) return null
  const sorted = [...actions].sort((a, b) => a.name.localeCompare(b.name))
  return (
    <dialog ref={dialogRef} className="sheet objective-actions-sheet" onCancel={(event) => { event.preventDefault(); onClose() }} onClose={onClose}>
      <div className="sheet__body objective-actions-sheet__body">
        <div className="sheet__handle" />
        <div className="sheet__heading"><div><h2>{goalActions.title} {objective.name}</h2><p>{goalActions.intro}</p></div><button className="icon-button" type="button" onClick={onClose} aria-label={common.close}><CloseIcon /></button></div>
        {sorted.length === 0 ? <div className="specializations-empty">{goalActions.empty}</div> : <div className="objective-action-list">{sorted.map((action) => { const linked = action.objectiveIds.includes(objective.id); return <button key={action.id} className={linked ? 'objective-action-row objective-action-row--linked' : 'objective-action-row'} type="button" disabled={saving} onClick={() => void onToggle(action)}><span className="objective-checkbox">{linked && <CheckIcon />}</span><span><strong>{action.name}</strong><small>{specializationNames(action.categoryIds, specializations).join(' + ') || common.noSkill}</small></span></button> })}</div>}
      </div>
    </dialog>
  )
}
